const clearComma = (num = '') => num.replaceAll(',', '');

export const displayFloats = (num = 0.0, digits = 2) => {
  try {
    const validatedNum = num !== null ? +num : 0.0;
    const result = validatedNum.toFixed(digits) || 0.0;
    return +result;
  } catch (error) {
    console.error({ error });
  }
};
